import React, { Component, Fragment } from "react";
import { FormattedMessage } from "react-intl";
import CheckboxFormGroup from "assets/scripts/components/common/form/CheckboxFormGroup/CheckboxFormGroup";
import Message from "assets/scripts/components/common/Message/Message";
import classNames from "classnames";
import isEmpty from "assets/scripts/utils/isEmpty";
class AccountFormGroup extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        const { balance, primary } = props.routeGroup;
        const { refNum } = primary;
        let label = props.hideBalance ? (<FormattedMessage id="forms.contactSecure.accounts.textNoBalance" defaultMessage="Reference #{refNum}" values={{ refNum }}/>) : (<FormattedMessage id="forms.contactSecure.accounts.text" defaultMessage="Reference #{refNum}, Balance: {balance, number, usd}" values={{
            refNum,
            balance
        }}/>);
        if (primary.deceased) {
            const decLastName = props.routeGroup.decLastName || primary.lastName;
            if (!isEmpty(decLastName) && !props.hideBalance) {
                label = (<Fragment>
						{label}, {decLastName}
					</Fragment>);
            }
        }
        return (<CheckboxFormGroup label={label} value={props.selectedIds[this._getIdentifier()] || false} onChange={this._handleChange}/>);
    }
    _handleChange(value) {
        this.props.onChange({
            ...this.props.selectedIds,
            [this._getIdentifier()]: value
        });
    }
    _getIdentifier() {
        const account = this.props.routeGroup.primary;
        return this.props.useRefNum ? account.refNum : account.id;
    }
}
const AccountFormGroups = (props) => (<fieldset className={classNames("fieldset", props.className)}>
		<legend>
			<span className="label">
				<Message value={props.label}/>
			</span>
		</legend>

		{props.routeGroups.map(routeGroup => (<AccountFormGroup key={routeGroup.primary.id} {...props} routeGroup={routeGroup}/>))}
	</fieldset>);
export default AccountFormGroups;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/AccountFormGroups/AccountFormGroups.tsx